module.exports = __webpack_public_path__ + "static/Scalable-architecture-Unexpected-Usage-eddd5893af11350be205b57321f50c5b.png";